import { SVGGridSlice } from 'interfaces/GeneratedLandingPage'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    @media (max-width: 1050px) {
        height: auto;
    }
`

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    place-items: center;
    grid-gap: 50px;
    row-gap: 100px;
    padding-bottom: 100px;

    @media (max-width: 750px) {
        padding: 2.5%;
        grid-gap: 50px;
        row-gap: 50px;
    }
`

interface Props {
    items: SVGGridSlice['items']
}

const SVGGrid = ({ items }: Props) => {
    return (
        <Container>
            <section>
                <Grid>
                    {items.map((item, i) => (
                        <img
                            key={`svg-grid-item-${i}`}
                            src={item.image.url}
                            alt={`svg-grid-item-${i}`}
                            width={item.image.dimensions?.width}
                            height={item.image.dimensions?.height}
                        />
                    ))}
                </Grid>
            </section>
        </Container>
    )
}

export default SVGGrid
